import { render, staticRenderFns } from "./TagView.vue?vue&type=template&id=7258777f&scoped=true&"
import script from "./TagView.vue?vue&type=script&lang=js&"
export * from "./TagView.vue?vue&type=script&lang=js&"
import style0 from "./TagView.vue?vue&type=style&index=0&id=7258777f&prod&lang=scss&scoped=true&"
import style1 from "./TagView.vue?vue&type=style&index=1&id=7258777f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7258777f",
  null
  
)

export default component.exports